module.exports = "/_next/static/media/microsoft-edge-icon.2352136c.png";